<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">

        <div class="flex">
          <ul class="topBox">
            <li class="flex">
              <span>ID：</span>
              <div style="width: 140px">
                <el-input
                  v-model="searchId"
                  placeholder="用户ID"
                  clearable
                  @keyup.enter.native="searchFn"
                />
              </div>
            </li>

            <li class="flex">
              <span>昵称：</span>
              <div style="width: 240px">
                <el-input
                  v-model="searchVle"
                  placeholder="模糊搜索"
                  clearable
                  @keyup.enter.native="searchFn"
                />
              </div>
            </li>

            <li class="flex">
              <span>是否小法官：</span>
              <div style="width: 140px">
                <el-select v-model="searchJurorEnabled" placeholder="全部" clearable @change="searchFn">
                  <el-option
                    v-for="o in jurorYesNoOptions"
                    :key="String(o.value)"
                    :label="o.label"
                    :value="o.value"
                  />
                </el-select>
              </div>
            </li>

            <li class="flex">
              <span>小法官等级：</span>
              <div style="width: 160px">
                <el-select v-model="searchJurorLevel" placeholder="全部" clearable @change="searchFn">
                  <el-option
                    v-for="o in jurorLevelFilterOptions"
                    :key="String(o.value)"
                    :label="o.label"
                    :value="o.value"
                  />
                </el-select>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
              <el-button size="small" @click="resetSearchFn">重置</el-button>
            </li>
          </ul>

        </div>


        <!-- 主体内容 -->
        <div>
          <div class="table-scroll-wrap">
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px" @row-click="clickData">

            <el-table-column prop="id" width="100" align="center" label="ID">
            </el-table-column>
            <el-table-column type="index" align="center" label="头像" width="100">
              <template slot-scope="scope">
                <div>
                  <img :src="scope.row.photo" style="width: 45px; height: 45px" alt="" srcset="" />
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="nickName" align="center" label="昵称">
            </el-table-column>

            <el-table-column prop="scentId" align="center" label="会员名" min-width="120">
              <template slot-scope="scope">
                {{ scope.row.scentId || "-" }}
              </template>
            </el-table-column>

            <el-table-column prop="time" align="center" label="注册时间">
            </el-table-column>

            <el-table-column align="center" label="实名认证" min-width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.idCardAuthStatus === 1" class="auth-cell">
                  <div v-if="scope.row.realName">{{ scope.row.realName }}</div>
                  <div v-if="scope.row.idCardNo">{{ scope.row.idCardNo }}</div>
                  <div v-if="scope.row.idCardPhone">{{ scope.row.idCardPhone }}</div>
                </div>
                <span v-else>{{ authStatusLabel(scope.row.idCardAuthStatus) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="收款方式认证" min-width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.receiptAuthStatus === 1" class="auth-cell">
                  <div v-if="scope.row.receiptCardName">户名：{{ scope.row.receiptCardName }}</div>
                  <div v-if="scope.row.receiptCardNo">卡号：{{ scope.row.receiptCardNo }}</div>
                </div>
                <span v-else>{{ authStatusLabel(scope.row.receiptAuthStatus) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="canFastIdentify" align="center" label="快速下单">
              <template slot-scope="scope">
                <el-switch
                  v-loading="scope.row.loading"
                  :value="scope.row.canFastIdentify"
                  :active-value="1"
                  :inactive-value="0"
                  @change="event=>onCanFastIdentifyChange(event,scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column prop="showAdminEntry" align="center" label="管理入口">
              <template slot-scope="scope">
                <el-switch
                  v-loading="scope.row.adminEntryLoading"
                  :value="scope.row.showAdminEntry"
                  :active-value="1"
                  :inactive-value="0"
                  @change="event=>onShowAdminEntryChange(event,scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column align="center" label="小法官" width="100">
              <template slot-scope="scope">
                <el-switch
                  v-loading="scope.row.jurorLoading"
                  :value="scope.row.jurorEnabled"
                  active-value="1"
                  inactive-value="0"
                  @change="(val) => onJurorEnabledChange(val, scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column align="center" label="小法官等级" width="140">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.jurorLevel"
                  size="mini"
                  :disabled="scope.row.jurorLevelLoading"
                  @change="(val) => onJurorLevelChange(val, scope.row)"
                  @click.native.stop
                >
                  <el-option
                    v-for="o in jurorLevelOptions"
                    :key="o.value"
                    :label="o.label"
                    :value="o.value"
                  />
                </el-select>
              </template>
            </el-table-column>

            <el-table-column align="center" label="裁决次数" width="100">
              <template slot-scope="scope">
                {{ scope.row.jurorReviewedCaseCount != null ? scope.row.jurorReviewedCaseCount : 0 }}
              </template>
            </el-table-column>

            <el-table-column align="center" label="准确率" width="100">
              <template slot-scope="scope">
                {{ jurorAccuracyLabel(scope.row) }}
              </template>
            </el-table-column>

          </el-table>
          </div>

          <list-pagination
            :total="tableTotal"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            @page-change="changePage"
            @size-change="handlePageSizeChange"
          />
        </div>
        <!-- 主体内容 -->
      </div>







    </div>
  </div>
</template>

<script>
import { delTips, returnTime } from "@/util/utils";


export default {
  components: {

  },
  data() {
    return {
      isPage: "index",

      dataList: {},

      surplusShow: 0,
      userList: "",

      // 历史记录
      historyArr: ["用户管理", "用户列表"],

      //  搜索
      searchId: "",
      searchVle: "",
      searchJurorEnabled: null,
      searchJurorLevel: null,

      // 搜索类型
      searchType: 1,
      searchData: [
        {
          id: 1,
          name: "昵称",
        },
        {
          id: 2,
          name: "手机号",
        },
      ],

      // 数据信息
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      // 用户密码
      delShow: 0, //删除提示
      delList: {},
      userPass: "",

      jurorLevelOptions: [
        { label: "初级小法官", value: 1 },
        { label: "中级小法官", value: 2 },
        { label: "高级小法官", value: 3 },
      ],
      jurorYesNoOptions: [
        { label: "是", value: "1" },
        { label: "否", value: "0" },
      ],
      jurorLevelFilterOptions: [
        { label: "初级小法官", value: 1 },
        { label: "中级小法官", value: 2 },
        { label: "高级小法官", value: 3 },
      ],
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    onCanFastIdentifyChange(canFastIdentify,row){
      const data = {
        id: row.id,
        nickName: row.nickName,
        canFastIdentify,
      }
      this.tableData.find(item=>item.id == row.id).loading = true
      this.$https(this.$api.api.upUser, data, "POST")
      .then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.tableData.find(item=>item.id == row.id).canFastIdentify = canFastIdentify
        }
      })
      .finally(e=>{
       this.tableData.find(item=>item.id == row.id).loading = false
      })

      console.log(data)
    },
    onShowAdminEntryChange(showAdminEntry, row) {
      const data = {
        id: row.id,
        nickName: row.nickName,
        showAdminEntry,
      }
      const item = this.tableData.find((i) => i.id == row.id)
      item.adminEntryLoading = true
      this.$https(this.$api.api.upUser, data, "POST")
        .then((res) => {
          if (res.data.code == 200) {
            item.showAdminEntry = showAdminEntry
          }
        })
        .finally(() => {
          item.adminEntryLoading = false
        })
    },
    jurorAccuracyLabel(row) {
      const graded = Number(row.jurorAccuracyGradedCount) || 0;
      if (graded <= 0) return "-";
      const wrong = Number(row.jurorWrongVoteCount) || 0;
      const rate = ((graded - wrong) / graded) * 100;
      return rate.toFixed(1) + "%";
    },
    onJurorEnabledChange(enabled, row) {
      const item = this.tableData.find((i) => i.id == row.id);
      if (!item) return;
      const prev = item.jurorEnabled === "1" ? "0" : "1";
      item.jurorLoading = true;
      this.$https(this.$api.api.updateSecondhandJuror, {
        userId: row.id,
        enabled: enabled != null ? String(enabled) : "0",
        level: item.jurorLevel != null ? item.jurorLevel : 1,
      }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            item.jurorEnabled = enabled != null ? String(enabled) : "0";
          } else {
            item.jurorEnabled = prev;
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .catch(() => {
          item.jurorEnabled = prev;
          this.$message.error("保存失败");
        })
        .finally(() => {
          item.jurorLoading = false;
        });
    },
    onJurorLevelChange(level, row) {
      const item = this.tableData.find((i) => i.id == row.id);
      if (!item) return;
      const prev = item.__prevJurorLevel != null ? item.__prevJurorLevel : 1;
      item.jurorLevelLoading = true;
      this.$https(this.$api.api.updateSecondhandJuror, {
        userId: row.id,
        level: level != null ? level : 1,
      }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            item.jurorLevel = level;
            item.__prevJurorLevel = level;
          } else {
            item.jurorLevel = prev;
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .catch(() => {
          item.jurorLevel = prev;
          this.$message.error("保存失败");
        })
        .finally(() => {
          item.jurorLevelLoading = false;
        });
    },
    // 搜索
    searchFn: function () {
      const idStr = String(this.searchId || "").trim();
      if (idStr && !/^\d+$/.test(idStr)) {
        this.$message.warning("用户ID须为正整数");
        return;
      }
      this.currentPage = 1;
      this.selListFn(1);
    },

    resetSearchFn() {
      this.searchId = "";
      this.searchVle = "";
      this.searchJurorEnabled = null;
      this.searchJurorLevel = null;
      this.currentPage = 1;
      this.selListFn(1);
    },

    clickData() {

    },

    /** 认证状态：0-未认证 1-已认证 */
    authStatusLabel(v) {
      if (v === 1) return "已认证";
      if (v === 0) return "未认证";
      return "-";
    },




    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
      };

      const idStr = String(this.searchId || "").trim();
      if (idStr) {
        obj.id = parseInt(idStr, 10);
      }

      if (this.searchVle) {
        obj.nickName = this.searchVle;
      }

      if (this.searchJurorEnabled != null && this.searchJurorEnabled !== "") {
        obj.jurorEnabled = this.searchJurorEnabled;
      }
      if (this.searchJurorLevel != null && this.searchJurorLevel !== "") {
        obj.jurorLevel = this.searchJurorLevel;
      }

      this.$https(this.$api.api.selUser, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.forEach(v => {
            v.time = v.createTime ? returnTime(new Date(v.createTime)) : "";

          });
          this.tableData = data.map(e=>{
            e.loading = false;
            e.adminEntryLoading = false;
            e.jurorLoading = false;
            e.jurorLevelLoading = false;
            e.jurorEnabled = e.jurorEnabled != null ? String(e.jurorEnabled) : "0";
            e.jurorLevel = e.jurorLevel != null ? e.jurorLevel : 1;
            e.jurorReviewedCaseCount = e.jurorReviewedCaseCount != null ? e.jurorReviewedCaseCount : 0;
            e.jurorAccuracyGradedCount = e.jurorAccuracyGradedCount != null ? e.jurorAccuracyGradedCount : 0;
            e.jurorWrongVoteCount = e.jurorWrongVoteCount != null ? e.jurorWrongVoteCount : 0;
            e.__prevJurorLevel = e.jurorLevel;
            return e
          });
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.selListFn(this.currentPage);
      this.isPage = "index";
      this.historyArr.pop();
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    handlePageSizeChange() {
      this.selListFn(this.currentPage);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delUser,
        {

          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }

  .auth-cell {
    line-height: 1.5;
    text-align: left;
    display: inline-block;
    font-size: 13px;
    color: #303133;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/userAdmin/index.vue